import Controller from '@ember/controller';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import logger from 'donor-elf-web/lib/logger';
import type LineItemModel from 'donor-elf-web/models/line-item';
import type FundsService from 'donor-elf-web/services/funds-service';
import type NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import type FlashMessageService from 'ember-cli-flash/services/flash-messages';

enum TransactionDeleteControllerState {
  Idle = 'idle',
  Deleting = 'deleting',
  Deleted = 'deleted',
}

export default class TransactionDeleteController extends Controller {
  declare model: { line: LineItemModel };

  @service declare fundsService: FundsService;
  @service declare flashMessages: FlashMessageService;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare router: RouterService;

  @tracked state = TransactionDeleteControllerState.Idle;

  reset() {
    this.state = TransactionDeleteControllerState.Idle;
  }

  delete = async () => {
    try {
      const line = this.model.line;

      this.state = TransactionDeleteControllerState.Deleting;
      await line.destroyRecord();

      this.state = TransactionDeleteControllerState.Deleted;

      this.flashMessages.success('The transaction was deleted');
      this.router.transitionTo('funds.fund.transactions');
    } catch (error: any) {
      logger.error(error);

      this.flashMessages.danger('There was an error deleting the transaction');
      this.state = TransactionDeleteControllerState.Idle;
    }
  };
}
